import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {EventTrackerService} from '@app/core';

import {TabComponent} from '../tab/tab.component';

@Component({
  selector: 'navaar-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  @Input('selected-index-tab') private selectedIndexTab: number;

  constructor(private readonly eventTracker: EventTrackerService) {
  }

  ngAfterContentInit() {
    if (this.tabs) {
      if (this.selectedIndexTab) {
        this.selectTab(this.tabs.find((element, index) => index === this.selectedIndexTab), false);
        return;
      }
      let activeTabs = this.tabs.filter((tab) => tab.active);
      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.first, false);
      }
    }
  }

  selectTab(tab: TabComponent, selectedByUser: boolean) {
    // deactivate all tabs
    this.tabs.toArray().forEach(tab => tab.active = false);
    // activate the tab the user has clicked on.
    tab.active = true;
    tab.onClick.emit(tab.name);
    // set focus table
    if (tab.index == 1 && tab.table) {
      tab.table.nativeElement.focus();
      setTimeout(() => {
        let tbl = document.querySelectorAll(".tab-table");

        if (tbl.length && tbl[0] != null) {
          let table = tbl[0];
          table.scrollLeft = 9999;
          //tbl.click();
        }
      }, 0);
    }
    if (selectedByUser) {
      // this.eventTracker.logEvent('x_tab_select', {
      //   'location_screen': 'audiobook-detail',
      //   'x_tab_name': tab.title
      // });
    }

  }
}
